/** @format */

import { useEffect, useState } from "react";

//importing components
import DynamicTable from "../../components/global/DynamicTable";
//import components
import HeadTitle from "../../components/global/HeadTitle";

import {
  BlockBtn,
  BtnRed,
  MenuBtn,
  UnBLock,
} from "../../components/global/btns/btns";

//import table data
import {
  tableColumnDriverslastOrder,
  tableColumnDriversOrders,
} from "../../components/table/col-data";
import { InternalNav } from "../../components/internalNav";
import { PersonalForm } from "../../components/drivers/Personal-info";
import { UserCard } from "../../components/global/user-card";
import Table from "../../components/Table2";
import {
  ColumnDriverslastOrder,
  ColumnDriversOrders,
} from "../../constant/table";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";
import { useDispatch, useSelector } from "react-redux";
import { getOne, getOneDetails } from "../../store/helper";
import { useParams } from "react-router-dom";
import { Spinner1 } from "../../components/spinners/Spinner1";
import { getClientOrders } from "../../services/clintServices";
import { banDriver, getOrderDrivers } from "../../store/drivers";
import ActionModal from "../../components/pops/global modals/action-modal";

const ProfileDriver = () => {
  const [active, setActive] = useState("last-orders");
  const [isOpen, setOpen] = useState(false);
  const [selectedAction, setActionObj] = useState(false);
  const dispatch = useDispatch();

  const params = useParams();
  const drivers = useSelector((state) => state.drivers);
  // const ordersInfo = useSelector((state) => state.drivers.orders)

  const handleBanClick = (status) => {
    dispatch(
      banDriver({
        id: params.id,
        params: { status: status },
      })
    ).then((res) => {
      dispatch(getOne({ path: "/driver/profile/", id: params.id }));
      setOpen(false);
    });
  };
  useEffect(() => {
    dispatch(getOne({ path: "/driver/profile/", id: params.id }));
    dispatch(getClientOrders("/driver/" + params.id + "/orders"));
    dispatch(getOrderDrivers("/driver/statistics/" + params.id));
  }, [dispatch, params.id]);
  let modalOj = {
    bane: {
      type: "bane",
      title: "هل تريد حظر هذا السائق ؟",
      action: () => handleBanClick("inactive"),
    },
    delete: {
      type: "delete",
      title: "هل تريد حذف هذا الكفيل ؟",
      action: console.log(">>>>>>"),
    },
    activate: {
      type: "activate",
      title: "هل تريد اعادة تفعيل هذا السائق ؟",
      action: () => handleBanClick("active"),
    },
  };
  const actionBtn = (buttonName) => {
    setOpen(true);

    setActionObj(modalOj[buttonName]);
  };
  return (
    <NavbarAndSidebar>
      {drivers.loading && <Spinner1 />}
      <ActionModal
        data={drivers}
        type={selectedAction.type}
        showModal={isOpen}
        setShowModal={setOpen}
        msg={selectedAction.title}
        action={selectedAction.action}
      />
      <div className='profile__head mb__small'>
        <HeadTitle title='السائق' margin={true} />
        <div className='row-flex'>
          {drivers.status === "active" ? (
            <BtnRed action={() => actionBtn("bane")} value='حظر' />
          ) : (
            <UnBLock action={() => actionBtn("activate")} />
          )}
        </div>
      </div>
      <UserCard
        role='سائق'
        name={drivers?.driver.name}
        created={drivers?.driver.created_at}
        photo={drivers?.driver.image}
      />
      <div className='mb__small' />
      <InternalNav active={active} setActive={setActive} from='driver' />
      <div className='mb__small' />

      {active === "last-orders" && (
        <Table
          data={drivers?.orders}
          header={ColumnDriverslastOrder}
          link='/history/'
          // getSearchValue={getSearchValue}
          // searchValues={searchValues}
          name='driversLastOrders'
        />
        // <DynamicTable tableColumn={tableColumnDriverslastOrder} />
      )}

      {active === "orders" && (
        <Table
          data={[drivers?.totalOrders]}
          header={ColumnDriversOrders}
          // link="history"
          // getSearchValue={getSearchValue}
          // searchValues={searchValues}
          name='driversOrders'
        />
      )}
      {active === "personal-info" && <PersonalForm data={drivers?.driver} />}
    </NavbarAndSidebar>
  );
};
export default ProfileDriver;
